<template>
  <div class="contact-container">
    <div class="title">{{$t('home.Contacts')}}</div>
    <div class="item-container">
      <div v-for="item in contactList" class="inner-container" :key="item.uid">
        <input
          class="checkbox"
          type="checkbox"
          :id="item.uid"
          :value="removeSearchType(item)"
          v-model="$store.state.sessionAdd.friendsSelectedMembers"
          @click="changeIfLessThan32"
          :disabled="isDisabled(item.uid)"
        >
        <label :for="item.uid" class="label-container">
          <slot :contact="item"></slot>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { omit } from 'ramda'

export default {
  name: 'contact',
  props: {
    contactList: {
      type: Array,
      default: function () {
        return []
      }
    },
    disableCheckboxList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    removeSearchType(item) {
      // 为了保证filteredContactList中的数据与friendsSelectedMembers匹配，删除其中新增的 searchType 字段
      // return dissoc('searchType', item)
      // 增加删除roomId和deviceType属性
      return omit(['searchType', 'roomId', 'deviceType'], item)
    },
    changeIfLessThan32(e){
      if (e.target.checked && this.$store.getters['sessionAdd/selectedMembers'].length + 1 > 32) {
        this.$message.warn(this.$t('home.More32Members'))
        e.preventDefault()
      }
    },
    isDisabled(uid) {
      return this.disableCheckboxList.includes(uid)
    }
  }
}
</script>

<style scoped lang="less">
.contact-container {
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #999B9F;
  }
  .item-container {
    .inner-container {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      font-weight: 400;
      color: #333;
      display: flex;
      flex-direction: row;
      align-items: center;
      &>input.checkbox {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: none;
        margin-right: 16px;
        -webkit-appearance: none;
        appearance: none;
        outline: none;
        vertical-align: center;
        cursor: pointer;
        background: url(~@/assets/unchecked.svg) no-repeat center;
        &:checked {
          background-image: url(~@/assets/checked.svg);
        }
        &:disabled {
          cursor: not-allowed;
          &+.label-container {
            cursor: not-allowed;
          }
        }
      }
      .label-container {
        cursor: pointer;
        .checkbox-label-container {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
      ::v-deep .mobile-container {
        height: 40px;
        display: flex;
        flex-direction: column;
        .name {
          height: 22px;
          line-height: 22px;
        }
        .mobile {
          height: 18px;
          line-height: 18px;
          font-size: 12px;
          font-weight: 400;
          color: #999B9F;
        }
      }
    }
  }
}
</style>
